import api from './api'

const ReportsService = {
  /**
   * Lista todos os relatórios disponíveis
   * @param {Object} params - Filtros opcionais (category, search, team_id, period, format)
   * @returns {Promise} Lista de relatórios e categorias
   */
  list(params = {}) {
    return api.get('api/reports', { params })
  },

  /**
   * Gera e baixa um relatório
   * @param {Number} reportId - ID do relatório
   * @param {Object} data - Configurações do relatório (format, period, team_id, filters)
   * @returns {Promise} Arquivo binário do relatório
   */
  async generate(reportId, data) {
    console.log('📤 Enviando request para backend:', {
      endpoint: `api/reports/${reportId}/generate`,
      body: data,
    })
    
    const response = await api.post(`api/reports/${reportId}/generate`, data, {
      responseType: 'blob', // Importante para receber arquivo binário
    })
    
    console.log('✅ Response recebida:', {
      status: response.status,
      contentType: response.headers['content-type'],
      size: response.data.size,
    })
    
    return response
  },

  /**
   * Helper para fazer download do relatório
   * @param {Number} reportId - ID do relatório
   * @param {String} reportTitle - Título do relatório (para nome do arquivo)
   * @param {Object} config - Configurações (format, period, team_id, filters)
   */
  async downloadReport(reportId, reportTitle, config) {
    try {
      const response = await this.generate(reportId, config)
      
      // Extrair extensão do formato
      const format = config.format.toLowerCase()
      const extensions = {
        pdf: 'pdf',
        xlsx: 'xlsx',
        csv: 'csv',
      }
      const extension = extensions[format] || format

      // Criar nome do arquivo
      const date = new Date().toISOString().split('T')[0]
      const filename = `${reportTitle.replace(/\s+/g, '_')}_${date}.${extension}`

      // Criar blob e fazer download
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      return { success: true, filename }
    } catch (error) {
      console.error('Erro ao baixar relatório:', error)
      throw error
    }
  },
}

export default ReportsService
